import { Observable } from 'rxjs';

import { Period, UserTimezone } from '@daikin-tic/dxone-com-lib';

import { ArchiveMeasurementFile, ArchiveMeasurementFileUpdateParams } from '../models/archive.model';

export abstract class MeasurementFileArchiveUsecase {
  abstract get measurementFiles$(): Observable<ArchiveMeasurementFile[]>;
  abstract get period$(): Observable<Period>;

  abstract changeTimezone(timezone: UserTimezone): void;
  abstract changePeriod(period: Period): void;
  abstract reload(): void;

  abstract getArchiveMeasurement(channelId: string, measurementId: string): Observable<string>;
  abstract updateArchiveMeasurementFile(
    channelId: string,
    measurementId: string,
    params: ArchiveMeasurementFileUpdateParams,
  ): Observable<never>;
}
